import React from "react";
import { CheckCircle, Clock } from "../../../components/icons/svg/outline";
import { getPayrollStatusItems } from "./summaryUtils";

/**
 * Displays compact weekly payroll status indicators.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.statuses - Payroll action status object.
 * @returns {JSX.Element} Status chip row.
 */
const PayrollStatusChips = ({ statuses }) => {
  const items = getPayrollStatusItems(statuses);

  return (
    <div className="flex flex-nowrap items-center gap-1 whitespace-nowrap">
      {items.map((item) => {
        const Icon = item.complete ? CheckCircle : Clock;
        const chipClass = item.complete
          ? "border-green-200 bg-green-50 text-green-800"
          : "border-yellow-200 bg-yellow-50 text-yellow-800";

        return (
          <span
            key={item.key}
            className={`inline-flex flex-shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] ${chipClass}`}
          >
            <Icon className="h-3 w-3" />
            {item.label}
          </span>
        );
      })}
    </div>
  );
};

export default PayrollStatusChips;
